import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobleApiService } from "../../../services";
import { CookieService } from 'ngx-cookie-service';
declare var $: any; 
import { environment } from "../../../../../environments/environment";

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.css']
})
export class ChangePasswordModalComponent implements OnInit {

  myForm: FormGroup;
  password_incurrect: boolean =false;
  fieldTextType: boolean;
  currentPasswordTextType: boolean=false;
  showOnlyEye: Boolean = false;
  @Input() isShow:boolean = false
  @Output() save: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _formBuilder: FormBuilder , private API: GlobleApiService,private cookieService: CookieService) { }

  ngOnChanges(){
    if(this.isShow){
      $('#check-password').modal('show');
    }else{
      $('#check-password').modal('hide');
    }
  }

  ngOnInit() {
  
    this.formInitialize()
  }
  formInitialize(){
    this.myForm = this._formBuilder.group({
      current_password:['' , Validators.required],
      new_password:['',Validators.required]

    })
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  togglecurrentPasswordTextType() {
    this.currentPasswordTextType = !this.currentPasswordTextType;
  }

  handleChange(){
    console.log(this.myForm.value.current_password);
    this.checkCurrentPassword(this.myForm.value.current_password)
    if(this.myForm.value.current_password == ''){
      this.showOnlyEye = true;
    }else{
      this.showOnlyEye = false;
    }
  }

  checkCurrentPassword(data){
    let body ={
      "current_password": data,
    }
    this.API.$checkPasswordAndChangePasword(body).subscribe((doc:any) =>{
      console.log(doc,"&&&&");
      if(doc.success == true){
        this.password_incurrect = false;
      }else{
        this.password_incurrect = true;
      }
    })
  }

  saveChangePassword(){
    console.log(this.myForm.value)
    if(this.myForm.invalid){
      return;
    } else {
      this.password_incurrect = false;
      this.API.$checkPasswordAndChangePasword(this.myForm.value).subscribe((data:any) =>{
        if (data.success == true) {
          $('#check-password').modal('hide');
          if (data.with_out_mail == true) {
            this.cookieService.set('_EMAIL_N', '0' , 100000, '/', environment.uiHost, false);
          }
          if (data.with_mail == true) {
            this.cookieService.set('_EMAIL_N', '1' ,  100000, '/', environment.uiHost, false);
          }

          // setTimeout(()=>{
          //   this.logout()
          // },2000);

          // this.profileLoader = false;
          this.save.emit(true)
        } else {
          this.save.emit(false)
          this.password_incurrect = true;
          // this.profileLoader = false;
        }
      })

    }
  }


}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-modal-module/change-password-modal/change-password-modal.component.ts